import {
  apiData,
  apiRequest
} from "./http.js";


const LEADERBOARD_TYPES =
  new Set([
    "country_score",
    "system_progress"
  ]);


export async function getLeaderboard({
  type = "country_score"
} = {}) {
  if (
    !LEADERBOARD_TYPES.has(type)
  ) {
    throw new Error(
      `Unsupported leaderboard type: ${type}`
    );
  }

  const query =
    new URLSearchParams({
      type
    });

  return apiData(
    await apiRequest(
      `/api/game/leaderboard?${query.toString()}`,
      {
        method: "GET"
      }
    )
  );
}
